export default __webpack_public_path__ + "static/media/polls_obj_default.86db65c6.png";